import { useState, useEffect } from "react";
import "./index.scss";
import { Menubar } from "primereact/menubar";
import { useNavigate } from "react-router-dom";
import logo from "../../assets/img/logos/logo-waima-principal.png";

export default function MenubarLanding() {
  const navigate = useNavigate();
  const [language, setLanguage] = useState(localStorage.getItem("lang") || "es");
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleLanguageChange = () => {
      setLanguage(localStorage.getItem("lang") || "es");
    };

    window.addEventListener("languageChange", handleLanguageChange);

    // Detectar scroll
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("languageChange", handleLanguageChange);
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const switchLanguage = (lang) => {
    setLanguage(lang);
    localStorage.setItem("lang", lang);
    window.dispatchEvent(new Event("languageChange"));
  };

  const items = [
    {
      label: language === "es" ? "Inicio" : "Home",
      icon: "pi pi-fw pi-home",
      command: () => {
        navigate("/");
        window.scrollTo({ top: 0, behavior: "smooth" });
      },
    },
    {
      label: language === "es" ? "Acerca de" : "About",
      icon: "pi pi-fw pi-info-circle",
      command: () => {
        navigate("/about");
        window.scrollTo({ top: 0, behavior: "smooth" });
      },
    },
    {
      label: language === "es" ? "Programas & Campañas" : "Programs & Campaigns",
      icon: "pi pi-fw pi-book",
      command: () => {
        navigate("/program");
        window.scrollTo({ top: 0, behavior: "smooth" });
      },
    },
    {
      label: language === "es" ? "Informes DIAN" : "Reports DIAN",
      icon: "pi pi-fw pi-list-check",
      className: "reports-submenu-item",
      items: [
        { label: language === "es" ? "Informe DIAN 2025" : "Report DIAN 2025", icon: "pi pi-fw pi-file" , command: () => {navigate("/reports", { state: { year: '2025' } }); window.scrollTo({ top: 0, behavior: "smooth" });}},
        { label: language === "es" ? "Informe DIAN 2024" : "Report DIAN 2024", icon: "pi pi-fw pi-file" , command: () => {navigate("/reports", { state: { year: '2024' } }); window.scrollTo({ top: 0, behavior: "smooth" });}},
        { label: language === "es" ? "Informe DIAN 2023" : "Report DIAN 2023", icon: "pi pi-fw pi-file" , command: () => {navigate("/reports", { state: { year: '2023' } }); window.scrollTo({ top: 0, behavior: "smooth" });}},
        { label: language === "es" ? "Informe DIAN 2022" : "Report DIAN 2022", icon: "pi pi-fw pi-file" , command: () => {navigate("/reports", { state: { year: '2022' } }); window.scrollTo({ top: 0, behavior: "smooth" });}},
        { label: language === "es" ? "Informe DIAN 2021" : "Report DIAN 2021", icon: "pi pi-fw pi-file" , command: () => {navigate("/reports", { state: { year: '2021' } }); window.scrollTo({ top: 0, behavior: "smooth" });}},
        { label: language === "es" ? "Informe DIAN 2020" : "Report DIAN 2020", icon: "pi pi-fw pi-file" , command: () => {navigate("/reports", { state: { year: '2020' } }); window.scrollTo({ top: 0, behavior: "smooth" });}},
        { label: language === "es" ? "Informe DIAN 2019" : "Report DIAN 2019", icon: "pi pi-fw pi-file" , command: () => {navigate("/reports", { state: { year: '2019' } }); window.scrollTo({ top: 0, behavior: "smooth" });}},
        { label: language === "es" ? "Informe DIAN 2018" : "Report DIAN 2018", icon: "pi pi-fw pi-file" , command: () => {navigate("/reports", { state: { year: '2018' } }); window.scrollTo({ top: 0, behavior: "smooth" });}},
        { label: language === "es" ? "Informe DIAN 2017" : "Report DIAN 2017", icon: "pi pi-fw pi-file" , command: () => {navigate("/reports", { state: { year: '2017' } }); window.scrollTo({ top: 0, behavior: "smooth" });}}
      ],
    },
    {
      label: language === "es" ? "Contacto" : "Contact",
      icon: "pi pi-fw pi-envelope",
      command: () => {
        navigate("/contact");
        window.scrollTo({ top: 0, behavior: "smooth" });
      },
    },
    {
      label: language === "es" ? "Idioma" : "Language",
      icon: "pi pi-fw pi-globe",
      items: [
        {
          label: "English",
          icon: "pi pi-fw pi-globe",
          command: () => switchLanguage("en"),
        },
        {
          label: "Español",
          icon: "pi pi-fw pi-globe",
          command: () => switchLanguage("es"),
        },
      ],
    },
  ];

  const start = (
    <img
      alt="logo"
      src={logo}
      height="70"
      className="menubar-logo"
      style={{ cursor: "pointer" }}
      onClick={() => {navigate("/"); window.scrollTo({ top: 0, behavior: "smooth" });}}
    />
  );


  return (
    <div className="menubar-height">
      <div className={`menubar-landing ${isScrolled ? "scrolled" : ""}`}>
        <Menubar className="border-radius-0" model={items} start={start} />
      </div>
    </div>
  );
}
